import React from "react";

const FaqTree: React.FC = () => {
  return (
    <div className="overflow-x-auto">
      <b>Faq</b>
      <div className="whitespace-pre">
        <div>
          <span className="font-mono">.</span>
        </div>
        <div>
          <span className="font-mono md:hidden">├</span>
          <span className="font-mono hidden md:inline">├──</span>
          <span> Une personne propose un film</span>
        </div>
        <div>
          <span className="font-mono md:hidden">├</span>
          <span className="font-mono hidden md:inline">├──</span>
          <span> Le Cinemir contrôle les droits</span>
        </div>
        <div>
          <span className="font-mono md:hidden">│ └</span>
          <span className="font-mono hidden md:inline">│   └──</span>
          <span> Et si le film ne prône pas le nazisme ou autre</span>
        </div>
        <div>
          <span className="font-mono md:hidden">├</span>
          <span className="font-mono hidden md:inline">├──</span>
          <span> Si le film est validé il rejoint le fond de la liste</span>
        </div>
        <div>
          <span className="font-mono md:hidden">├</span>
          <span className="font-mono hidden md:inline">├──</span>
          <span> Les gens peuvent alors participer à son financement</span>
        </div>
        <div>
          <span className="font-mono md:hidden">├</span>
          <span className="font-mono hidden md:inline">├──</span>
          <span> Les films qui reçoivent du financement remontent la liste</span>
        </div>
        <div>
          <span className="font-mono md:hidden">├</span>
          <span className="font-mono hidden md:inline">├──</span>
          <span> Si un film est financé à 100%</span>
        </div>
        <div>
          <span className="font-mono md:hidden">│ ├</span>
          <span className="font-mono hidden md:inline">│   ├──</span>
          <span> Il est programmé (en VOST) à la prochaine date disponible</span>
        </div>
        <div>
          <span className="font-mono md:hidden">│ ├</span>
          <span className="font-mono hidden md:inline">│   ├──</span>
          <span> Les personnes qui ont financé le film ont une place réservée</span>
        </div>
        <div>
          <span className="font-mono md:hidden">│ │ └</span>
          <span className="font-mono hidden md:inline">│   │   └──</span>
          <span> 25 min avant projection</span>
        </div>
        <div>
          <span className="font-mono md:hidden">│ └</span>
          <span className="font-mono hidden md:inline">│   └──</span>
          <span> Les autres personnes remplissent les places restantes</span>
        </div>
        <div>
          <span className="font-mono md:hidden">│ │ └</span>
          <span className="font-mono hidden md:inline">│   │   └──</span>
          <span> 40 places maximum</span>
        </div>
        <div>
          <span className="font-mono md:hidden">└</span>
          <span className="font-mono hidden md:inline">└──</span>
          <span> Si un film n'est pas financé après 1 an</span>
        </div>
        <div>
          <span className="font-mono md:hidden">  ├</span>
          <span className="font-mono hidden md:inline">    ├──</span>
          <span> Les gens qui le veulent sont remboursés</span>
        </div>
        <div>
          <span className="font-mono md:hidden">  ├</span>
          <span className="font-mono hidden md:inline">    ├──</span>
          <span> Le reste va dans la cagnote</span>
        </div>
        <div>
          <span className="font-mono md:hidden">  └</span>
          <span className="font-mono hidden md:inline">    └──</span>
          <span> La cagnote finance le matériel</span>
        </div>
      </div>
    </div>
  );
};

export default FaqTree;
